/* eslint-disable camelcase */
/* eslint-disable jsx-quotes */
/* eslint-disable quotes */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import history from '../../history';
import routes from '../../utils/routes';

import Paginator from '../Paginator';

import Loader from '../loader-component/loader';
import ItemQuestion from './components/ItemQuestion';

import {
    fetchQuestions,
    changeShowModalConfirmDisable,
    asyncEnableQuestion,
    asyncRemoveQuestion,
    changeShowModalConfirmRemove,
    changeShouldBeRefreshQuestionsDatabase,
} from './questions-database.actions';

import './questions-database.css';

class QuestionsDatabase extends Component {
    constructor(props) {
        super(props);
        this.state = {
            questions: [],
            total: 0,
            orderBy: '',
            orderMode: '',
            limit: 25,
            page: 0,
            searchTitle: '',
            statusFilter: '',
            enabledFilter: '',
            activeId: null,
            showDescriptionStatus: false,
        };
    }

    componentDidMount() {
        const { orderBy, orderMode, limit, page } = this.state;
        const { total } = this.props;
        this.fetchQuestionsToRender({
            orderBy,
            orderMode,
            limit,
            page,
        });
        this.setState({ total });
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            questions,
            total,
            shouldBeRefresh,
            changeShouldBeRefreshQuestionsDatabase,
        } = this.props;
        const {
            limit,
            page,
            orderBy,
            orderMode,
            searchTitle,
            enabledFilter,
            statusFilter,
        } = this.state;

        if (prevProps.questions !== questions) {
            this.setState({ questions });
        }

        if (prevProps.total !== total) {
            this.setState({ total });
        }

        if (
            prevState.limit !== limit ||
            prevState.page !== page ||
            prevState.searchTitle !== searchTitle ||
            prevState.enabledFilter !== enabledFilter ||
            prevState.statusFilter !== statusFilter ||
            prevState.orderBy !== orderBy ||
            prevState.orderMode !== orderMode ||
            (prevProps.shouldBeRefresh !== shouldBeRefresh && shouldBeRefresh)
        ) {
            this.fetchQuestionsToRender({
                orderBy,
                orderMode,
                limit,
                page,
                searchTitle: searchTitle,
                enabled: enabledFilter,
                status: statusFilter,
            });

            if (shouldBeRefresh) {
                changeShouldBeRefreshQuestionsDatabase(false);
            }
        }
    }

    fetchQuestionsToRender({
        orderBy,
        orderMode,
        limit,
        page,
        searchTitle,
        testId,
        enabled,
        status,
    }) {
        const addParams = {};
        if (enabled !== undefined && enabled !== '') {
            Object.assign(addParams, {
                enabled: enabled === 'true' ? true : false,
            });
        }

        this.props.fetchQuestions({
            orderBy,
            orderMode,
            limit,
            page,
            searchTitle,
            testId,
            status,
            ...addParams,
        });
    }

    onChangePage(newPage) {
        this.setState({ page: newPage });
    }

    onChangeRowsPerPage(newLimit) {
        this.setState({ limit: newLimit, page: 0 });
    }

    handlePortalConfirmDisableQuestion() {
        const showPortal = this.props.showModalConfirmDisable;
        this.props.changeShowModalConfirmDisable(!showPortal);
    }

    handleConfirmDisable(question) {
        this.props.asyncEnableQuestion({
            questionId: question.id,
            title: question.title,
            enabled: !question.enabled,
            options: question.options.map(option => {
                return {
                    ...option,
                    correct:
                        question.correct_option_id === option.id ? true : false,
                };
            }),
        });
    }

    handlePortalConfirmRemoveQuestion() {
        const showPortal = this.props.showModalConfirmRemove;
        this.props.changeShowModalConfirmRemove(!showPortal);
    }

    handleConfirmRemove(questionId) {
        this.props.asyncRemoveQuestion({
            questionId: questionId,
        });
    }

    gotoManageQuestion(questionId) {
        history.push(
            routes.MANAGE_QUESTION.replace(':question_id', questionId),
        );
    }

    gotoDuplicateQuestion(questionId) {
        history.push(
            routes.DUPLICATE_QUESTION.replace(':question_id', questionId),
        );
    }

    goToAddQuestion() {
        history.push(routes.ADD_QUESTION);
    }

    handleActiveId(newId) {
        this.setState({ activeId: newId });
    }

    handleShowDescriptionStatus(newShowDescriptionStatus) {
        this.setState({
            showDescriptionStatus: newShowDescriptionStatus,
        });
    }

    render() {
        const {
            questions,
            total,
            limit,
            searchTitle,
            enabledFilter,
            statusFilter,
            orderBy,
            orderMode,
            activeId,
            showDescriptionStatus,
        } = this.state;
        const {
            loading,
            showModalConfirmDisable,
            showModalConfirmRemove,
        } = this.props;
        return (
            <section className="container-questions-database">
                <header className="header-questions-database">
                    <span className="content-filters">
                        <div className="field">
                            <label>Buscar questões</label>
                            <input
                                placeholder="Buscar questões"
                                className="input"
                                type="text"
                                onChange={({ target }) =>
                                    this.setState({
                                        searchTitle: target.value,
                                    })
                                }
                                value={searchTitle}
                            />
                        </div>
                        <div className="field">
                            <label>Ordenação</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({ orderBy: target.value })
                                }
                                value={orderBy}
                            >
                                <option value="">Selecionar</option>
                                <option value="created_at">Criado em</option>
                                <option value="updated_at">Editado em</option>
                            </select>
                        </div>
                        <div className="field">
                            <label>Tipo da ordenação</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({
                                        orderMode: target.value,
                                    })
                                }
                                value={orderMode}
                            >
                                <option value="">Selecionar</option>
                                <option value="asc">Crescente</option>
                                <option value="desc">Decrescente</option>
                            </select>
                        </div>
                        <div className="field">
                            <label>Status</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({
                                        statusFilter: target.value,
                                    })
                                }
                                value={statusFilter}
                            >
                                <option value="">Selecionar</option>
                                <option value={'INCOMPLETE'}>Incompleto</option>
                                <option value={'READY'}>Completo</option>
                                <option value={'LINKED'}>Vinculado</option>
                                <option value={'LINKED_ANSWERED'}>
                                    Respondido
                                </option>
                            </select>
                        </div>
                        <div className="field">
                            <label>Disponibilidade</label>
                            <select
                                className="input"
                                onChange={({ target }) =>
                                    this.setState({
                                        enabledFilter: target.value,
                                    })
                                }
                                value={enabledFilter}
                            >
                                <option value="">Selecionar</option>
                                <option value={true}>Ativo</option>
                                <option value={false}>Inativo</option>
                            </select>
                        </div>
                    </span>
                    <button
                        className="add-btn"
                        type="button"
                        onClick={this.goToAddQuestion}
                    >
                        Adicionar
                    </button>
                </header>
                <section className="table-grid">
                    <div className="table-grid-header">
                        <span>
                            <p>Título</p>
                        </span>
                        <span className="container-title-status">
                            <p
                                className="title-status"
                                onClick={() =>
                                    this.handleShowDescriptionStatus(
                                        !showDescriptionStatus,
                                    )
                                }
                                title="Clique para ver mais detalhes"
                            >
                                Status <i className="fa fa-info-circle" />
                            </p>
                            {showDescriptionStatus && (
                                <div className="container-info">
                                    <span
                                        className="background-info"
                                        onClick={() =>
                                            this.handleShowDescriptionStatus(
                                                !showDescriptionStatus,
                                            )
                                        }
                                    ></span>
                                    <span className="content-info">
                                        <span className="header-info">
                                            <h1>Informações</h1>
                                            <i
                                                className="fa fa-times-circle icon"
                                                onClick={() =>
                                                    this.handleShowDescriptionStatus(
                                                        !showDescriptionStatus,
                                                    )
                                                }
                                            />
                                        </span>
                                        <p>
                                            <strong>Incompleto:</strong> Questão
                                            com menos de 2 opções cadastradas
                                            e/ou sem opção de resposta correta;
                                        </p>
                                        <p>
                                            <strong>Completo:</strong> Questão
                                            tem 2 ou mais opções e já possui uma
                                            opção selecionada como resposta
                                            correta;
                                        </p>
                                        <p>
                                            <strong>Vinculado:</strong> Status
                                            dado a questão completa após ela ser
                                            vinculada a pelo menos um teste.
                                        </p>
                                        <p>
                                            <strong>Respondido:</strong> Status
                                            dado a uma questão vinculada que já
                                            foi respondida pelo menos uma vez em
                                            algum teste.
                                        </p>
                                    </span>
                                </div>
                            )}
                        </span>
                        <span>
                            <p>Disponibilidade</p>
                        </span>
                        <span>
                            <p>Criado em</p>
                        </span>
                        <span>
                            <p>Editado em</p>
                        </span>
                        <span>
                            <p>Ações</p>
                        </span>
                    </div>
                    {questions &&
                        questions.length > 0 &&
                        questions.map(question => (
                            <ItemQuestion
                                key={question.id}
                                question={question}
                                activeId={activeId}
                                gotoManageQuestion={this.gotoManageQuestion.bind(
                                    this,
                                )}
                                correct_question_id={question.correct_option_id}
                                handleConfirmDisable={this.handleConfirmDisable.bind(
                                    this,
                                )}
                                handlePortalDisable={this.handlePortalConfirmDisableQuestion.bind(
                                    this,
                                )}
                                handleConfirmRemove={this.handleConfirmRemove.bind(
                                    this,
                                )}
                                handlePortalRemove={this.handlePortalConfirmRemoveQuestion.bind(
                                    this,
                                )}
                                showModalConfirmDisable={
                                    showModalConfirmDisable
                                }
                                showModalConfirmRemove={showModalConfirmRemove}
                                handleActiveId={this.handleActiveId.bind(this)}
                                gotoDuplicateQuestion={this.gotoDuplicateQuestion.bind(
                                    this,
                                )}
                            />
                        ))}
                </section>
                {questions.length === 0 && (
                    <p className="not-found-question">
                        Questões não encontradas
                    </p>
                )}
                <Paginator
                    totalRows={total}
                    onChangePage={this.onChangePage.bind(this)}
                    onChangeRowsPerPage={this.onChangeRowsPerPage.bind(this)}
                    rowsPerPage={Number(limit)}
                />
                {loading > 0 && (
                    <Loader
                        show={loading > 0 ? true : false}
                        message={'Carregando, por favor aguarde...'}
                    />
                )}
            </section>
        );
    }
}

const mapStateToProps = ({ questionsDatabase, onlineTests }) => ({
    questions: questionsDatabase.questions,
    total: questionsDatabase.total,
    loading: onlineTests.loading,
    showModalConfirmDisable: questionsDatabase.showModalConfirmDisable,
    showModalConfirmRemove: questionsDatabase.showModalConfirmRemove,
    shouldBeRefresh: questionsDatabase.shouldBeRefresh,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchQuestions,
            changeShowModalConfirmDisable,
            asyncEnableQuestion,
            asyncRemoveQuestion,
            changeShowModalConfirmRemove,
            changeShouldBeRefreshQuestionsDatabase,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsDatabase);



// WEBPACK FOOTER //
// ./src/components/questions-database/questions-database.js